// Traducciones comunes - Español
export const commonEs = {
  // Acciones generales
  actions: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    view: 'Ver',
    close: 'Cerrar',
    next: 'Siguiente',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    clear: 'Limpiar',
    apply: 'Aplicar',
    contact: 'Contactar',
    send: 'Enviar',
    share: 'Compartir',
  },

  // Estados
  states: {
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    empty: 'Vacío',
    notFound: 'No encontrado',
  },

  // Formularios
  forms: {
    required: 'Este campo es obligatorio',
    invalidEmail: 'Correo electrónico inválido',
    invalidPhone: 'Número de teléfono inválido',
    minLength: 'Mínimo {min} caracteres',
    maxLength: 'Máximo {max} caracteres',
  },

  // Monedas y formatos
  currency: {
    clp: 'CLP',
    usd: 'USD',
    eur: 'EUR',
  },

  // Unidades
  units: {
    km: 'km',
    miles: 'millas',
    year: 'año',
    years: 'años',
  },
};


